module.exports = __webpack_public_path__ + "static/media/lucy4cloud-logo-white.e2aacfee.svg";